"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const emptyList1x = require('../../assets/placeholder/empty-list.png');
const emptyList2x = require('../../assets/placeholder/empty-list@2x.png');
const emptyList3x = require('../../assets/placeholder/empty-list@3x.png');
function EmptyListPlaceholder() {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'EmptyListPlaceholder_Container', children: [(0, jsx_runtime_1.jsx)(StyledImg, { srcSetArray: [
                    emptyList1x.default,
                    emptyList2x.default,
                    emptyList3x.default,
                ].map(url => `${url}`), "data-e2e": 'EmptyListPlaceholder_StyledImg' }), (0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'EmptyListPlaceholder_StyledTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.emptyListPlaceholder) })] }));
}
exports.default = EmptyListPlaceholder;
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.library.cellBackground};
  width: 100vw;
  height: 100vh;
  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    transform: translateY(-44px);
  `)}
  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    transform: translateY(-16px);
  `)}
`;
const StyledImg = (0, styled_components_1.default)(ui_1.ResponsiveImg) `
  max-width: 100%;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    flex: 1;
    max-height: 41vh;
    object-fit: contain;
  `)}
`;
const StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 16px;
  line-height: normal;
  margin-top: 44px;
  color: ${props => props.theme.text};
  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin-top: 22px;
  `)}
`;
